import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const patientService = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/patients`,

  create(patient) {
    return viperApi.post(this.basePath(patient.organization.id), patient)
  },

  update(organizationId, patient) {
    return viperApi.put(this.basePath(organizationId) + `/${patient.id}`, patient)
  },

  get(organizationId, params) {
    return viperApi.get(this.basePath(organizationId), {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, {})
      }
    })
  },

  findById(organizationId, patientId) {
    return viperApi.get(this.basePath(organizationId) + `/${patientId}`)
  }
}
